import React from "react";
import { Link } from "react-router-dom";
import "./NotFoundPage.css";

function NotFoundPage() {
  return (
    <main className="not-found-page">
      <section className="not-found-card">
        <p className="not-found-code">404</p>
        <h1 className="not-found-title">Page Not Found</h1>
        <p className="not-found-message">
          The page you are looking for does not exist.
        </p>
        <Link className="not-found-home-link" to="/">
          Go Back Home
        </Link>
      </section>
    </main>
  );
}

export default NotFoundPage;
